import { render, staticRenderFns } from "./TransfertCommande.vue?vue&type=template&id=1b3f9952&scoped=true"
import script from "./TransfertCommande.vue?vue&type=script&lang=js"
export * from "./TransfertCommande.vue?vue&type=script&lang=js"
import style0 from "./TransfertCommande.vue?vue&type=style&index=0&id=1b3f9952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3f9952",
  null
  
)

export default component.exports